// extracted by mini-css-extract-plugin
export default {"container":"ErrorMessage_container__d4AGn"};